import React from "react";

export default function SyaratKetentuan() {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "20px 16px 40px",
        color: "#4B2E05",
        lineHeight: 1.7,
      }}
    >
      <h1 style={{ marginBottom: 8 }}>Syarat dan Ketentuan</h1>
      <p style={{ marginTop: 0, color: "#6f5a3e" }}>
        Berlaku untuk penggunaan platform Sahabat Kakao (web dan aplikasi mobile).
      </p>

      <h3>1. Penggunaan Layanan</h3>
      <p>
        Pengguna wajib menggunakan layanan secara sah, tidak menyalahgunakan fitur,
        serta menjaga keamanan akun masing-masing.
      </p>

      <h3>2. Data dan Privasi</h3>
      <p>
        Data yang Anda isi (profil, lokasi, pesanan, forum, dan aktivitas layanan)
        digunakan untuk operasional platform, peningkatan layanan, dan komunikasi
        terkait kebutuhan pengguna.
      </p>
      <p>
        Kami berkomitmen menjaga kerahasiaan data pengguna dan tidak menjual data
        pribadi kepada pihak lain tanpa persetujuan, kecuali diwajibkan oleh hukum.
      </p>

      <h3>3. Konten Pengguna</h3>
      <p>
        Pengguna bertanggung jawab atas konten yang diunggah, termasuk teks, foto,
        dan informasi lainnya. Konten yang melanggar hukum atau merugikan pihak lain
        dapat dihapus oleh pengelola platform.
      </p>

      <h3>4. Ketersediaan Layanan</h3>
      <p>
        Kami berupaya menjaga layanan tetap tersedia, namun tidak menjamin layanan
        selalu bebas gangguan teknis setiap saat.
      </p>

      <h3>5. Perubahan Ketentuan</h3>
      <p>
        Syarat dan ketentuan dapat diperbarui sewaktu-waktu. Perubahan akan berlaku
        sejak dipublikasikan pada halaman ini.
      </p>

      <h3>6. Kontak</h3>
      <p>
        Untuk pertanyaan terkait kebijakan privasi dan ketentuan penggunaan, silakan
        hubungi tim Sahabat Kakao melalui kanal resmi yang tersedia.
      </p>
    </div>
  );
}
